export var getTimeSimplifiedDurationFn = function (_a, nbrRoundZeros) {
    var startTime = _a.startTime, maxDuration = _a.duration;
    var roundNbr = Math.pow(10, nbrRoundZeros);
    var round = function (value) { return Math.ceil(value / roundNbr) * roundNbr; };
    return function (time) {
        var rawDuration = Math.max(maxDuration - (time - startTime), 0);
        return Math.min(round(rawDuration), maxDuration);
    };
};
